export class TriggersTagsModel {
    data;
}
//# sourceMappingURL=triggers-tags.js.map